import { makeAutoObservable } from "mobx";
import { IReturngoFeesSetting} from "../models/User";

interface IReturngoFeesSettingChanges extends Partial<IReturngoFeesSetting> { };

class ReturngoFeesSettingStore {
    private _model: IReturngoFeesSetting;
    private _changes: IReturngoFeesSettingChanges = {};

    constructor(returngo_fees_setting: IReturngoFeesSetting) {
        makeAutoObservable(this, {}, { autoBind: true });
        this._model = ensureValidModel(returngo_fees_setting);
    }

    public get addTax() {
        return this._changes.add_tax ?? this._model.add_tax;
    }

    public get feeType() {
        return this._changes.fee_type ?? this._model.fee_type;
    }

    public setAddTax(v: boolean) {
        this._changes.add_tax = v;
        this._clearChangesIfEqual('add_tax');
    }

    public setFeeType(v: string) {
        this._changes.fee_type = v;
        this._clearChangesIfEqual('fee_type');
    }

    public discardChanges() {
        this._changes = {} as IReturngoFeesSetting;
    }

    public hasChanges() {
        return !!Object.keys(this._changes).length;
    }

    private _clearChangesIfEqual(key: keyof IReturngoFeesSetting): void {
        if (this._changes[key] === this._model?.[key]) {
            delete this._changes[key];
        }
    }

    public getUpdatedModel(): IReturngoFeesSetting {
        return { ...this._model, ...this._changes };
    }

}

export default ReturngoFeesSettingStore;

function ensureValidModel(data: IReturngoFeesSetting): IReturngoFeesSetting {
    const toBool = (v: undefined | any) => {
        if (typeof v === 'string') {
            return Boolean(Number(v));
        }
        return Boolean(v);
    };

    return {
        ...data,
        add_tax: toBool(data.add_tax),
        fee_type: data.fee_type
    };
}